import { Link } from "react-router-dom";

/* ============================================================================
 * Klink — Bright, optimistic, mass-market consumer
 * Soft pastel coral + butter-yellow accents, Outfit + Figtree, rounded pills.
 * ========================================================================== */

const PALETTE = {
  bg: "#FFFDF9", surface: "#FFFFFF", coral: "#FF8A66", butter: "#FFD166",
  text: "#2B2826", muted: "#857F7A", verifiedBg: "#E8F3EE", verifiedText: "#2D8059",
};
const DISPLAY = "'Outfit', system-ui, sans-serif";
const BODY = "'Figtree', system-ui, sans-serif";

export default function MockupKlink() {
  return (
    <div style={{ background: PALETTE.bg, color: PALETTE.text, fontFamily: BODY, minHeight: "100vh" }}>
      <TopBar />

      <section style={{ maxWidth: 1180, margin: "0 auto", padding: "0 28px 100px" }}>
        <Section label="01 · LANDING">
          <KlinkLanding />
        </Section>

        <Section label="02 · EXTENSION POPUP">
          <div style={{ display: "flex", justifyContent: "center", padding: "60px 0", background: "linear-gradient(135deg, #FFF7EF 0%, #FFEFEA 100%)", borderRadius: 24 }}>
            <KlinkPopup />
          </div>
        </Section>

        <Section label="03 · CONSUMER DASHBOARD">
          <KlinkDashboard />
        </Section>
      </section>
    </div>
  );
}

function TopBar() {
  return (
    <div style={{ position: "sticky", top: 0, zIndex: 20, background: "rgba(255,253,249,0.85)", backdropFilter: "blur(20px)", borderBottom: "1px solid #F2EDE6" }}>
      <div style={{ maxWidth: 1180, margin: "0 auto", padding: "16px 28px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Link to="/mockups" style={{ fontSize: 12, color: PALETTE.muted, textDecoration: "none", fontWeight: 600 }}>← Alle retninger</Link>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ width: 28, height: 28, borderRadius: "50%", background: PALETTE.coral }} />
          <span style={{ fontFamily: DISPLAY, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>klink.</span>
        </div>
        <span style={{ fontSize: 11, letterSpacing: "0.2em", color: PALETTE.muted, fontWeight: 600 }}>RETNING 01</span>
      </div>
    </div>
  );
}

function Section({ label, children }) {
  return (
    <div style={{ paddingTop: 64 }}>
      <div style={{ fontSize: 11, letterSpacing: "0.3em", color: PALETTE.muted, fontWeight: 700, marginBottom: 20 }}>{label}</div>
      {children}
    </div>
  );
}

function KlinkLanding() {
  return (
    <div style={{ background: PALETTE.surface, borderRadius: 32, overflow: "hidden", boxShadow: "0 30px 80px rgba(43,40,38,0.06)" }}>
      <nav style={{ padding: "28px 48px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ width: 32, height: 32, borderRadius: "50%", background: PALETTE.coral, display: "grid", placeItems: "center", color: "#fff", fontSize: 14, fontWeight: 800, fontFamily: DISPLAY }}>k</span>
          <span style={{ fontFamily: DISPLAY, fontSize: 22, fontWeight: 800, letterSpacing: "-0.02em" }}>klink.</span>
        </div>
        <div style={{ display: "flex", gap: 28, fontSize: 14, color: PALETTE.muted, fontWeight: 500 }}>
          <span>Slik virker det</span><span>Belønninger</span><span>Priser</span>
        </div>
        <button style={{ background: PALETTE.text, color: "#fff", border: "none", padding: "10px 22px", borderRadius: 999, fontFamily: BODY, fontWeight: 600, fontSize: 14, cursor: "pointer" }}>Logg inn</button>
      </nav>

      <div style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 48, padding: "40px 48px 80px", alignItems: "center" }}>
        <div>
          <span style={{ display: "inline-block", padding: "6px 14px", background: PALETTE.verifiedBg, color: PALETTE.verifiedText, borderRadius: 999, fontSize: 13, fontWeight: 600, marginBottom: 24 }}>✨ Ny — for norske handlere</span>
          <h1 style={{ fontFamily: DISPLAY, fontSize: "clamp(48px, 6vw, 76px)", fontWeight: 800, letterSpacing: "-0.04em", lineHeight: 0.98, margin: 0, marginBottom: 24 }}>
            Få mer ut av <span style={{ color: PALETTE.coral }}>hver handel.</span>
          </h1>
          <p style={{ fontSize: 18, lineHeight: 1.55, color: PALETTE.muted, margin: "0 0 36px", maxWidth: 480 }}>
            Klink finner betalingsmetodene og bonusprogrammene som gjelder akkurat der du handler — slik at du aldri går glipp av poeng eller cashback igjen.
          </p>
          <div style={{ display: "flex", gap: 12, alignItems: "center", flexWrap: "wrap" }}>
            <button style={{ background: PALETTE.coral, color: "#fff", border: "none", padding: "16px 28px", borderRadius: 999, fontFamily: BODY, fontWeight: 700, fontSize: 16, cursor: "pointer", boxShadow: "0 10px 30px rgba(255,138,102,0.35)" }}>Prøv gratis i 14 dager</button>
            <span style={{ color: PALETTE.muted, fontSize: 14 }}>Deretter <strong style={{ color: PALETTE.text }}>15 kr/mnd</strong> · Avslutt når du vil</span>
          </div>
          <div style={{ marginTop: 56, display: "flex", gap: 32, fontSize: 13, color: PALETTE.muted }}>
            <span>★★★★★ 4.8 i butikken</span><span>12 000+ aktive nordmenn</span>
          </div>
        </div>

        <div style={{ position: "relative", height: 460 }}>
          <div style={{ position: "absolute", inset: 0, background: PALETTE.butter, borderRadius: "50% 40% 60% 50%", transform: "rotate(-8deg)" }} />
          <div style={{ position: "absolute", top: 30, right: 0, width: 280, padding: 24, background: "#fff", borderRadius: 28, boxShadow: "0 20px 50px rgba(43,40,38,0.12)" }}>
            <div style={{ fontSize: 11, color: PALETTE.muted, fontWeight: 600, marginBottom: 8, letterSpacing: "0.08em" }}>KOMPLETT.NO</div>
            <div style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "6px 12px", background: PALETTE.verifiedBg, color: PALETTE.verifiedText, borderRadius: 999, fontSize: 12, fontWeight: 600, marginBottom: 18 }}>✓ Trygg butikk</div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 18 }}>
              {["Visa","Mastercard","Vipps","Klarna"].map((m) => <span key={m} style={{ fontSize: 12, padding: "5px 11px", background: "#F6F2EC", borderRadius: 999, fontWeight: 600 }}>{m}</span>)}
            </div>
            <div style={{ padding: 14, background: PALETTE.butter, borderRadius: 16 }}>
              <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", marginBottom: 4 }}>🎁 SAS EUROBONUS</div>
              <div style={{ fontSize: 15, fontWeight: 700 }}>Tjen 15 poeng / 100 kr</div>
            </div>
          </div>
          <div style={{ position: "absolute", bottom: 20, left: 10, padding: "14px 20px", background: "#fff", borderRadius: 999, boxShadow: "0 12px 30px rgba(43,40,38,0.1)", display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ width: 38, height: 38, borderRadius: "50%", background: PALETTE.coral, display: "grid", placeItems: "center", color: "#fff", fontWeight: 800 }}>🪙</span>
            <div>
              <div style={{ fontSize: 11, color: PALETTE.muted, fontWeight: 600 }}>DENNE MÅNEDEN</div>
              <div style={{ fontSize: 18, fontWeight: 800, fontFamily: DISPLAY }}>1 240 poeng</div>
            </div>
          </div>
        </div>
      </div>

      {/* Feature + pricing */}
      <div style={{ padding: "0 48px 64px" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 18, marginBottom: 56 }}>
          {[
            { e: "🛒", t: "Se hva butikken godtar", b: "Visa, Mastercard, Vipps, Klarna eller Apple Pay — før du er i kassen." },
            { e: "🎯", t: "Aldri gå glipp av bonus", b: "Trumf, EuroBonus og Coop-medlemskap matches automatisk." },
            { e: "🔔", t: "Stille i bakgrunnen", b: "Ingen popup-spam. Klink dukker opp kun når det faktisk lønner seg." },
          ].map((f) => (
            <div key={f.t} style={{ padding: 28, background: "#FFF8F2", borderRadius: 24 }}>
              <div style={{ fontSize: 32, marginBottom: 14 }}>{f.e}</div>
              <div style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 19, marginBottom: 8 }}>{f.t}</div>
              <div style={{ color: PALETTE.muted, fontSize: 14, lineHeight: 1.55 }}>{f.b}</div>
            </div>
          ))}
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1.3fr", gap: 32, padding: 40, background: "#2B2826", borderRadius: 32, color: "#fff", alignItems: "center" }}>
          <div>
            <div style={{ fontSize: 11, letterSpacing: "0.3em", color: PALETTE.butter, fontWeight: 700, marginBottom: 12 }}>KLINK MEDLEMSKAP</div>
            <div style={{ fontFamily: DISPLAY, fontSize: 64, fontWeight: 800, letterSpacing: "-0.04em", lineHeight: 1 }}>15<span style={{ fontSize: 24, opacity: 0.7 }}> kr/mnd</span></div>
            <div style={{ fontSize: 14, color: "#BDB8B3", marginTop: 8 }}>Hver gang du handler.</div>
          </div>
          <div>
            <ul style={{ listStyle: "none", padding: 0, margin: 0, fontSize: 15, display: "grid", gap: 10 }}>
              {["Ubegrenset scanning av norske butikker","Bonus-tracker for alle programmer","Månedlig oversikt over opptjente poeng","Avslutt når som helst, ingen binding"].map((l) => (
                <li key={l} style={{ display: "flex", alignItems: "center", gap: 10 }}><span style={{ width: 22, height: 22, borderRadius: "50%", background: PALETTE.coral, display: "grid", placeItems: "center", fontSize: 12 }}>✓</span>{l}</li>
              ))}
            </ul>
            <button style={{ marginTop: 24, background: PALETTE.butter, color: PALETTE.text, border: "none", padding: "16px 28px", borderRadius: 999, fontFamily: BODY, fontWeight: 700, fontSize: 16, cursor: "pointer" }}>Start gratis prøveperiode →</button>
          </div>
        </div>
      </div>
    </div>
  );
}

function KlinkPopup() {
  return (
    <div style={{ width: 360, background: "#fff", borderRadius: 28, boxShadow: "0 30px 80px rgba(43,40,38,0.15)", overflow: "hidden", fontFamily: BODY }}>
      <div style={{ padding: "20px 24px 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ width: 24, height: 24, borderRadius: "50%", background: PALETTE.coral }} />
          <span style={{ fontFamily: DISPLAY, fontSize: 16, fontWeight: 800 }}>klink.</span>
        </div>
        <span style={{ fontSize: 18, color: PALETTE.muted, cursor: "pointer" }}>↻</span>
      </div>
      <div style={{ padding: "16px 24px 8px" }}>
        <div style={{ fontSize: 10, letterSpacing: "0.2em", color: PALETTE.muted, fontWeight: 700 }}>NÅ PÅ</div>
        <div style={{ fontSize: 17, fontWeight: 700, fontFamily: DISPLAY }}>komplett.no</div>
      </div>
      <div style={{ margin: "0 16px", padding: 16, background: PALETTE.verifiedBg, borderRadius: 20, display: "flex", alignItems: "center", gap: 12 }}>
        <span style={{ width: 38, height: 38, borderRadius: "50%", background: "#fff", display: "grid", placeItems: "center", fontSize: 18 }}>✓</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 11, color: PALETTE.verifiedText, fontWeight: 700, letterSpacing: "0.12em" }}>TRYGG BUTIKK</div>
          <div style={{ fontSize: 14, fontWeight: 700 }}>Komplett · 4 metoder</div>
        </div>
      </div>

      <div style={{ padding: "20px 24px 8px" }}>
        <div style={{ fontSize: 10, letterSpacing: "0.2em", color: PALETTE.muted, fontWeight: 700, marginBottom: 10 }}>BONUSPROGRAM</div>
        <div style={{ padding: 18, background: PALETTE.butter, borderRadius: 20, marginBottom: 10 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
            <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: "0.1em" }}>🎁 SAS EUROBONUS</span>
            <span style={{ fontSize: 11, color: PALETTE.text, opacity: 0.6, fontWeight: 600 }}>Åpne ↗</span>
          </div>
          <div style={{ fontFamily: DISPLAY, fontSize: 20, fontWeight: 800, lineHeight: 1.1 }}>Tjen 15 poeng / 100 kr</div>
        </div>
      </div>

      <div style={{ padding: "8px 24px 16px" }}>
        <div style={{ fontSize: 10, letterSpacing: "0.2em", color: PALETTE.muted, fontWeight: 700, marginBottom: 10 }}>BETALINGSMETODER</div>
        <div style={{ display: "grid", gap: 8 }}>
          {[
            { n: "Visa", c: PALETTE.coral, p: 99 },
            { n: "Mastercard", c: PALETTE.coral, p: 99 },
            { n: "Vipps", c: PALETTE.coral, p: 99 },
            { n: "Klarna", c: PALETTE.coral, p: 99 },
          ].map((m) => (
            <div key={m.n} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "10px 14px", background: "#FFF8F2", borderRadius: 14 }}>
              <span style={{ fontWeight: 600, fontSize: 14 }}>{m.n}</span>
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span style={{ width: 8, height: 8, borderRadius: "50%", background: PALETTE.verifiedText }} />
                <span style={{ fontSize: 11, fontWeight: 700, color: PALETTE.verifiedText }}>{m.p}%</span>
              </span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: "12px 24px 18px", borderTop: "1px solid #F4F0EA", display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 8 }}>
        <span style={{ fontSize: 11, color: PALETTE.muted, fontWeight: 600 }}>4/7 funnet · ai + mønster</span>
        <div style={{ display: "flex", gap: 6 }}>
          <button style={{ padding: "4px 10px", borderRadius: 999, background: PALETTE.text, color: "#fff", border: "none", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em" }}>NO</button>
          <button style={{ padding: "4px 10px", borderRadius: 999, background: "transparent", color: PALETTE.muted, border: "none", fontSize: 10, fontWeight: 700, letterSpacing: "0.1em" }}>EN</button>
        </div>
      </div>
    </div>
  );
}

function KlinkDashboard() {
  return (
    <div style={{ background: PALETTE.surface, borderRadius: 32, overflow: "hidden", boxShadow: "0 30px 80px rgba(43,40,38,0.06)", display: "grid", gridTemplateColumns: "240px 1fr" }}>
      <aside style={{ background: "#FFF8F2", padding: "32px 24px", borderRight: "1px solid #F2EDE6" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 36 }}>
          <span style={{ width: 32, height: 32, borderRadius: "50%", background: PALETTE.coral }} />
          <span style={{ fontFamily: DISPLAY, fontSize: 20, fontWeight: 800 }}>klink.</span>
        </div>
        {[["🏠","Oversikt",true],["🎯","Bonusprogram",false],["🛍️","Butikker",false],["💳","Betalinger",false],["⚙️","Innstillinger",false]].map(([e,l,a]) => (
          <div key={l} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", borderRadius: 14, background: a ? "#fff" : "transparent", marginBottom: 4, fontSize: 14, fontWeight: a ? 700 : 500, color: a ? PALETTE.text : PALETTE.muted, cursor: "pointer", boxShadow: a ? "0 4px 14px rgba(0,0,0,0.04)" : "none" }}>
            <span>{e}</span><span>{l}</span>
          </div>
        ))}
        <div style={{ marginTop: 40, padding: 18, background: "#fff", borderRadius: 20, boxShadow: "0 4px 14px rgba(0,0,0,0.04)" }}>
          <div style={{ fontSize: 11, letterSpacing: "0.2em", color: PALETTE.muted, fontWeight: 700 }}>ABONNEMENT</div>
          <div style={{ fontFamily: DISPLAY, fontWeight: 800, fontSize: 22, margin: "6px 0" }}>15 kr/mnd</div>
          <div style={{ fontSize: 12, color: PALETTE.muted }}>Fornyes 28. juli</div>
        </div>
      </aside>

      <main style={{ padding: "32px 36px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 28 }}>
          <div>
            <div style={{ fontSize: 12, color: PALETTE.muted, fontWeight: 600 }}>Velkommen tilbake</div>
            <div style={{ fontFamily: DISPLAY, fontSize: 32, fontWeight: 800, letterSpacing: "-0.02em" }}>Simen 👋</div>
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <button style={{ padding: "8px 16px", borderRadius: 999, border: "1px solid #E8E2DA", background: "#fff", fontSize: 12, fontWeight: 600 }}>🇳🇴 Bokmål</button>
            <span style={{ width: 36, height: 36, borderRadius: "50%", background: PALETTE.coral, display: "grid", placeItems: "center", color: "#fff", fontWeight: 800 }}>S</span>
          </div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1.4fr 1fr", gap: 18, marginBottom: 18 }}>
          <div style={{ padding: 28, background: PALETTE.butter, borderRadius: 24, position: "relative", overflow: "hidden" }}>
            <div style={{ fontSize: 11, letterSpacing: "0.25em", color: PALETTE.text, opacity: 0.6, fontWeight: 700, marginBottom: 12 }}>OPPTJENT I JUNI</div>
            <div style={{ fontFamily: DISPLAY, fontSize: 76, fontWeight: 800, letterSpacing: "-0.04em", lineHeight: 1 }}>1 240 <span style={{ fontSize: 28 }}>poeng</span></div>
            <div style={{ marginTop: 12, fontSize: 14, color: PALETTE.text, opacity: 0.75 }}>+18% vs forrige måned · Tilsvarer ca. 124 kr</div>
            <div style={{ position: "absolute", right: -20, bottom: -20, width: 140, height: 140, borderRadius: "50%", background: PALETTE.coral, opacity: 0.18 }} />
          </div>
          <div style={{ padding: 24, background: "#FFF8F2", borderRadius: 24 }}>
            <div style={{ fontSize: 11, letterSpacing: "0.25em", color: PALETTE.muted, fontWeight: 700, marginBottom: 12 }}>FORDELING</div>
            {[["SAS EuroBonus", 64, PALETTE.coral],["Trumf Netthandel", 28, PALETTE.butter],["Coop Medlem", 8, "#A5C8B0"]].map(([n,p,c]) => (
              <div key={n} style={{ marginBottom: 12 }}>
                <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13, fontWeight: 600, marginBottom: 4 }}><span>{n}</span><span>{p}%</span></div>
                <div style={{ height: 8, borderRadius: 999, background: "#F2EDE6", overflow: "hidden" }}><div style={{ height: "100%", width: `${p}%`, background: c, borderRadius: 999 }} /></div>
              </div>
            ))}
          </div>
        </div>

        <div style={{ padding: 24, background: "#fff", border: "1px solid #F2EDE6", borderRadius: 24 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
            <div style={{ fontFamily: DISPLAY, fontWeight: 700, fontSize: 18 }}>Siste butikker</div>
            <span style={{ fontSize: 12, color: PALETTE.muted, fontWeight: 600 }}>Se alle →</span>
          </div>
          {[
            ["komplett.no", "Komplett", ["Visa","Klarna"], "SAS · 15 p/100 kr", "i går"],
            ["meny.no", "Meny", ["Visa","Vipps"], "Trumf · 3%", "2 dager"],
            ["xxl.no", "XXL Sport", ["Mastercard","Klarna","Vipps"], "EuroBonus · 8 p/100 kr", "5 dager"],
            ["lego.com", "LEGO", ["Visa","Apple Pay"], "Trumf · 2%", "1 uke"],
          ].map(([h,n,m,b,t]) => (
            <div key={h} style={{ display: "grid", gridTemplateColumns: "1.4fr 1.6fr 1.2fr 80px", padding: "14px 8px", borderTop: "1px solid #F4F0EA", alignItems: "center", fontSize: 14 }}>
              <div><div style={{ fontWeight: 700 }}>{n}</div><div style={{ fontSize: 12, color: PALETTE.muted }}>{h}</div></div>
              <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>{m.map((x) => <span key={x} style={{ fontSize: 11, padding: "3px 9px", background: "#FFF8F2", borderRadius: 999, fontWeight: 600 }}>{x}</span>)}</div>
              <div style={{ fontSize: 12, color: PALETTE.verifiedText, fontWeight: 700 }}>{b}</div>
              <div style={{ fontSize: 12, color: PALETTE.muted, textAlign: "right" }}>{t}</div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
